// extracted by mini-css-extract-plugin
module.exports = {"container":"ExperienceCard_container__mL7aZ","image":"ExperienceCard_image__7tyRu","dash":"ExperienceCard_dash__rPXnr","star":"ExperienceCard_star__8HzwV"};